import { HTMLDivProps } from '@blueprintjs/core'
import * as React from 'react'
import CategoryRow from './CategoryRow'
import { CategoryColumnStyle } from './styles'
import { CategoryMultiselectCategory } from './types'

export interface CategoryColumnProps extends HTMLDivProps {
  categories: CategoryMultiselectCategory[]
  checkedSet: Set<number>
  highlightedPath: number[]

  onHighlight: (highlightedPath: number[]) => void
  onCheck: (category: CategoryMultiselectCategory) => void
}

const CategoryColumn: React.FC<CategoryColumnProps> = props => {
  const [currentHighlightId, ...rest] = props.highlightedPath
  const highlightedCategory = props.categories.find(c => c.id === currentHighlightId)
  const hasChildren = highlightedCategory && highlightedCategory.children.length > 0
  return (
    <>
      <div style={CategoryColumnStyle}>
        {props.categories.map(c => (
          <CategoryRow
            key={c.id}
            category={c}
            highlighted={currentHighlightId === c.id}
            checked={props.checkedSet.has(c.id)}
            onHighlight={props.onHighlight}
            hasChildren={c.children.length > 0}
            onCheck={props.onCheck}
          />
        ))}
      </div>
      {hasChildren && <CategoryColumn {...props} categories={highlightedCategory.children} highlightedPath={rest} />}
    </>
  )
}

export default CategoryColumn
